import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-aug-gray-light last:border-0">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full py-4 px-6 flex justify-between items-center hover:bg-aug-cream transition-colors duration-200 text-left"
        data-testid={`faq-item-${question.substring(0, 20)}`}
      >
        <span className="font-semibold text-aug-gray-dark pr-4">{question}</span>
        <ChevronDown 
          className={`w-5 h-5 text-aug-blue transition-transform duration-300 flex-shrink-0 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div 
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="px-6 pb-4 text-aug-gray-medium leading-relaxed">{answer}</p>
      </div>
    </div>
  );
};

const FAQAccordion = ({ faqs }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

export default FAQAccordion;